import React, { useState } from 'react'

// components
import SideViewModal from '../../../../components/modals/SideViewModal/SideViewModal.component'

// collections
import EditEquipment from '../EditEquipment.form'

// queries
import { useMutation } from '@apollo/client'
import { EDIT_EQUIPMENT } from '../../../../graphql/equipment/equipment.mutations'
import { apolloClient } from '../../../../index'
import { GET_EQUIPMENT_BY_ID_FOR_EDIT_FORM, GET_EQUIPMENT_BY_ID_WITH_NAME, GET_EQUIPMENT_BY_ID_WITH_QUANTITY, GET_EQUIPMENT_BY_ID_WITH_SPECIFICATIONS, GET_EQUIPMENT_BY_ID_WITH_DESCRIPTION, GET_EQUIPMENT_BY_ID_WITH_LOGS } from '../../../../graphql/equipment/equipment.queries'

// utils
import { validate } from '../../../../shared/utility'

const validationSchema = {
    sku: {
        type: 'input',
        validation: {
            required: true
        }
    },
    name: {
        type: 'input',
        validation: {
            required: true
        }
    },
    category: {
        type: 'input',
        validation: {
            required: true
        }
    },
    itemWeightInLbs: {
        type: 'input',
        validation: {
            required: true
        }
    }
}
export default function EditEquipmentFormController({ id, visible, closeForm }) {
    const [isFetchingObject, setIsFetchingObject] = useState(true)
    const [equipment, setEquipment] = useState(null)
    const [editEquipment, {}] = useMutation(EDIT_EQUIPMENT)
    const [errors, setErrors] = useState({})

    // handle the form submission
    const handleSubmit = (formData) => {
        const { isValid, errors } = validate(formData, validationSchema)
    
        if(isValid) {
            const submitData = {
                ...formData,
                id: parseInt(formData.id),
                category: parseInt(formData.category),
                itemWeightInLbs: parseFloat(formData.itemWeightInLbs)
            }
            
            editEquipment({ 
                variables: submitData, 
                refetchQueries: [
                    { query: GET_EQUIPMENT_BY_ID_WITH_NAME, variables: { id: parseInt(id) } },
                    { query: GET_EQUIPMENT_BY_ID_WITH_QUANTITY, variables: { id: parseInt(id) } },
                    { query: GET_EQUIPMENT_BY_ID_WITH_SPECIFICATIONS, variables: { id: parseInt(id) } },
                    { query: GET_EQUIPMENT_BY_ID_WITH_DESCRIPTION, variables: { id: parseInt(id) } },
                    { query: GET_EQUIPMENT_BY_ID_WITH_LOGS, variables: { id: parseInt(id) } },
                    { query: GET_EQUIPMENT_BY_ID_FOR_EDIT_FORM, variables: { id: parseInt(id) } }
                ]
            }).catch(e => {
                console.error(e)
            }).then(result => {
                if(result) {
                    setErrors({})
                    closeForm()
                }
            })
        } else {
            setErrors(errors)
        }
    }

    if(visible && isFetchingObject) {
        // fetch the data
        apolloClient.query({ 
            query: GET_EQUIPMENT_BY_ID_FOR_EDIT_FORM, 
            variables: { id: parseInt(id) }
        }).catch(e => {
            console.error(e)
        }).then(result => {
            if(result) {
                setEquipment({
                    ...result.data.equipment, 
                    category: result.data.equipment.category ? parseInt(result.data.equipment.category.id) : ""
                })
                setIsFetchingObject(false)
            }
        })
    
        return (null)
    }

    else if(visible && !isFetchingObject && equipment) {
        const variants = [
            {
                name: 'Edit Equipment',
                component: <EditEquipment />,
                stages: 1
            }
        ]

        return (<SideViewModal 
            show={visible} 
            submitText='Save Changes'
            onSubmit={handleSubmit}
            onClose={() => {
                setErrors({})
                closeForm()
            }} 
            title='Edit Equipment'
            variants={variants}    
            prefillData={equipment}
            errors={errors}
        />)
    }

    return null
}